import { useState, useRef } from "react";
import { connect } from "react-redux";
import {
  Section,
  LayoutContainer
} from "../../../../components/CustomLayout/CustomLayoutStyles";
import { useHistory, useLocation } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useUpdateEffect, useMountEffect } from "../../../../hooks/LifeCycle";
import { MainContent } from "../../styles/MainLayoutStandVirtualStyles";
import CustomMainNavBar from "../../../../components/CustomHeader/CustomMainNavBar";
import TittleLine from "../../../../components/Common/TittleLine";
import CheckRender from "../../../../components/Common/CheckRender";
import CustomAlert from "../../../../components/Common/CustomAlert";
import ModalLoader from "../../../../components/Common/ModalLoader";
import CustomButton from "../../../../components/CustomButton/CustomButton";
import useEmpresa from "../../../../hooks/useEmpresa";
import Colors from "../../../../themes/Colors";
import standVirtualRoutes from "../../standVirtualRoutes";
import CustomFileUpload from "../../../../components/CustomFileUpload/CustomFileUpload";
import Titulo from "../../shared/Titulo";

import precertificacionTypes from "../../../../stores/precertificacion/Actions";
import { isObjectEmpty } from "../../../../utils/ObjectUtil";
import { isValidPhone, isValidEmail } from "../../../../utils/ValidationUtil";
import { localToNumber } from "../../../../utils/NumberUtil";

import PrecertificacionDatosAfiliado from "../components/PrecertificacionDatosAfiliado";
import PrecertificacionDatosSolicitud from "../components/PrecertificacionDatosSolicitud";

const PrecertificacionModificarScreen = (props) => {
  const { id } = useParams();
  const empresa = useEmpresa();
  const history = useHistory();
  const location = useLocation();
  const [afiliado, setAfiliado] = useState();
  const [alertConfig, setAlertConfig] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [tiposSolicitudes, setTiposSolicitudes] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [certificacion, setCertificacion] = useState();
  const [procesando, setProcesando] = useState(false);
  const tiposSolicitudesRequestedRef = useRef(false);

  const goTo = (path) => {
    history.push(path);
  };

  const cargarTiposSolicitudesSiEsNecesario = () => {
    if (
      !tiposSolicitudesRequestedRef.current &&
      props.tiposSolicitudesPrecertificacionData === undefined &&
      !props.tiposSolicitudesPrecertificacionLoading
    ) {
      tiposSolicitudesRequestedRef.current = true;
      props.cargarTiposSolicitudesPrecertificacion();
    }
  };

  const handleDatosCertificacionStateChange =
    (key, format = null) =>
    (value) => {
      setCertificacion((prevState) => {
        return {
          ...prevState,
          [key]: format ? format(value) : value
        };
      });
    };

  const mostrarAlerta = (mensaje, tipo = "info", titulo = "¡Hola!") => {
    setAlertConfig({
      type: tipo,
      title: titulo,
      message: mensaje,
      onConfirm: () => {
        setShowAlert(false);
      }
    });
    setShowAlert(true);
  };

  const mostrarError = (mensaje) => {
    mostrarAlerta(mensaje, "error", "¡Error!");
  };

  const handleEnviarSolicitud = () => {
    if (!handleValidarDatosBasicos()) return;

    setAlertConfig({
      type: "confirm",
      title: "Confirmación",
      message: "¿Está seguro de que desea enviar la solicitud?",
      onConfirm: () => {
        setShowAlert(false);
        const { numeroSesionReutilizable: numeroSesion } = props?.authUserData;
        setProcesando(true);
        const datosSolicitud = {
          id,
          numeroSesion,
          informacion: {
            tipoSolicitud: certificacion.tipoSolicitud,
            telefono: certificacion.telefono,
            correo: certificacion.correo,
            medicoPrescriptor: certificacion.medicoPrescriptor,
            diagnostico: certificacion.diagnostico,
            comentarios: certificacion.comentarios
          },
          documentos: documents
        };

        props.modificarPrecertificacion(datosSolicitud);
      },
      onCancel: () => {
        setShowAlert(false);
      }
    });
    setShowAlert(true);
  };

  const handleValidarDatosBasicos = () => {
    if (!certificacion.tipoSolicitud) {
      mostrarError("Tipo de solicitud es requerido");
      return false;
    }

    if (!certificacion.telefono || !isValidPhone(certificacion.telefono)) {
      mostrarError("Teléfono es requerido y debe ser válido");
      return false;
    }

    if (!certificacion.correo || !isValidEmail(certificacion.correo)) {
      mostrarError("Correo electrónico es requerido y debe ser válido");
      return false;
    }

    if (!certificacion.medicoPrescriptor) {
      mostrarError("Médico prescriptor es requerido");
      return false;
    }
    if (!certificacion.diagnostico) {
      mostrarError("Diagnóstico es requerido");
      return false;
    }

    return true;
  };

  const handleMisSolicitudes = () => {
    const createNewRequest = `/${standVirtualRoutes.base.route}/${standVirtualRoutes.precertificacion.route}`;
    goTo(createNewRequest);
  };

  const handleCancelar = () => {
    setAlertConfig({
      type: "confirm",
      title: "Confirmación",
      message: "¿Está seguro de que desea cancelar?",
      onConfirm: () => {
        setShowAlert(false);
        const uri =
          `/${standVirtualRoutes.base.route}/${standVirtualRoutes.precertificacionVer.route}`.replace(
            ":id",
            id
          );
        goTo(uri);
      },
      onCancel: () => {
        setShowAlert(false);
      }
    });

    setShowAlert(true);
  };

  //Mostrar alerta de error
  useUpdateEffect(() => {
    if (
      props.tiposSolicitudesPrecertificacionError ||
      props.consultarUnaPrecertificacionError ||
      props.modificarCertificacionError
    ) {
      const { mensaje } =
        props.tiposSolicitudesPrecertificacionError ||
        props.consultarUnaPrecertificacionError ||
        props.modificarCertificacionError;

      mostrarError(mensaje);
      setProcesando(false);
    }
  }, [
    props.tiposSolicitudesPrecertificacionError ||
      props.consultarUnaPrecertificacionError ||
      props.modificarCertificacionError
  ]);

  //Error al cargar certificacion
  useUpdateEffect(() => {
    if (props.consultarUnaPrecertificacionError) {
      const { mensaje } = props.consultarUnaPrecertificacionError;
      mostrarError(mensaje);
      handleMisSolicitudes();
    }
  }, [props.consultarUnaPrecertificacionError]);

  //Cargar tipos de solicitudes
  useUpdateEffect(() => {
    if (props.tiposSolicitudesPrecertificacionData === undefined) return;

    if (
      !props.tiposSolicitudesPrecertificacionData ||
      props.tiposSolicitudesPrecertificacionData.length === 0
    ) {
      setAfiliado(null);
      mostrarError(
        "No se pudo cargar los tipos de solicitudes, por favor intente nuevamente"
      );
      return;
    }
    setTiposSolicitudes(props.tiposSolicitudesPrecertificacionData);
  }, [props.tiposSolicitudesPrecertificacionData]);

  //Cargar informacion asegurado
  useUpdateEffect(() => {
    if (isObjectEmpty(props.consultarAseguradoData)) return;

    const { afiliado, compania } = props.consultarAseguradoData;

    if (!afiliado.vigente) {
      mostrarError("El afiliado no está vigente en este plan");
      return;
    }

    if (localToNumber(empresa.CODIGO) !== compania.codigo) {
      mostrarError(
        <p>
          El número de asegurado digitado pertenece a {empresa.NOMBRE}, para
          procesar la solicitud de pre-certificación favor dirigirse a la página
          Autorizaciones (
          <a href={empresa.REDIRECT_COMPANY.URL} rel="noreferrer">
            {empresa.REDIRECT_COMPANY.NAME}
          </a>
          )
        </p>
      );
      return;
    }

    setAfiliado(afiliado);
    cargarTiposSolicitudesSiEsNecesario();
  }, [props.consultarAseguradoData]);

  useMountEffect(() => {
    // Si los datos de precertificacion vienen del state de navegación, usarlos directamente
    if (location.state?.precertificacion) {
      const precertificacionData = location.state.precertificacion;
      setCertificacion(precertificacionData);
      setAfiliado({
        nombre: precertificacionData?.nombreAsegurado,
        cedula: precertificacionData?.cedula,
        numeroPlastico: precertificacionData?.numeroPlastico,
        plan: precertificacionData?.descripcionPlan
      });
      cargarTiposSolicitudesSiEsNecesario();
    } else {
      // Si no hay datos en el state, hacer la llamada al API
      props.consultarUnaPrecertificacion({ id });
    }
  });

  // Cargar información de la certificación
  useUpdateEffect(() => {
    if (
      !props.consultarUnaPrecertificacionData &&
      !props.consultarUnaPrecertificacionData?.precertificacion
    )
      return;
    const { precertificacion } = props.consultarUnaPrecertificacionData;
    setCertificacion(precertificacion);
    setAfiliado({
      nombre: precertificacion?.nombreAsegurado,
      cedula: precertificacion?.cedula,
      numeroPlastico: precertificacion?.numeroPlastico,
      plan: precertificacion?.descripcionPlan
    });
    cargarTiposSolicitudesSiEsNecesario();
  }, [props.consultarUnaPrecertificacionData]);

  //enviar solicitud completado
  useUpdateEffect(() => {
    if (!procesando) return;

    setProcesando(false);
    setAlertConfig({
      type: "info",
      title: "!Información!",
      message: "Solicitud enviada correctamente",
      onConfirm: () => {
        setShowAlert(false);
        const uri =
          `/${standVirtualRoutes.base.route}/${standVirtualRoutes.precertificacionVer.route}`.replace(
            ":id",
            id
          );

        goTo(uri);
      }
    });
    setShowAlert(true);
  }, [props.modificarCertificacionData]);

  useUpdateEffect(() => {
    setShowAlert(false);
    setAlertConfig({});
  }, []);

  return (
    <LayoutContainer>
      <CustomMainNavBar />
      <MainContent>
        <CheckRender allowed={certificacion}>
          <Section>
            <TittleLine
              title={`Modificar Pre-Certificación ${certificacion?.numeroSolicitud} | Estado ${certificacion?.estado}`}
              customButton={
                <CustomButton
                  label="Stand Virtual"
                  bgColor={Colors.darkGreenPrimera}
                  hoverColor={Colors.LightGreenPrimera}
                  textColor={Colors.white}
                  hoverTextColor={Colors.white}
                  onClick={handleMisSolicitudes}
                  width="200px"
                  fontSize="16px"
                />
              }
            />
          </Section>

          <PrecertificacionDatosAfiliado afiliado={afiliado} />

          <CheckRender allowed={tiposSolicitudes.length > 0}>
            <PrecertificacionDatosSolicitud
              datosCertificacion={certificacion}
              tiposSolicitudes={tiposSolicitudes}
              onFieldChange={handleDatosCertificacionStateChange}
            />

            <div style={{ maxWidth: "93%", margin: "0 auto" }}>
              <Titulo titulo={"ADJUNTAR DOCUMENTOS"} />

              <CustomFileUpload
                accept=".jpg,.png,.jpeg,.pdf"
                multiple
                files={documents}
                setFiles={setDocuments}
                buttonColor={empresa?.COLOR_PRINCIPAL}
                isLabelWithContainer={true}
                maxWidth={"80%"}
              />
            </div>

            <Section gap={"10px"} marginTop={"20px"}>
              <CustomButton
                label={"Enviar Solicitud"}
                width={"200px"}
                onClick={handleEnviarSolicitud}
                isLoading={props.crearCertificacionLoading}
              />
              <CustomButton
                label={"Cancelar"}
                width={"200px"}
                onClick={handleCancelar}
                disabled={props.crearCertificacionLoading}
              />
            </Section>
          </CheckRender>
        </CheckRender>

        <CheckRender allowed={showAlert}>
          <CustomAlert {...alertConfig} />
        </CheckRender>

        <CheckRender
          allowed={
            props.tiposSolicitudesPrecertificacionLoading ||
            props.consultarUnaPrecertificacionLoading ||
            props.modificarCertificacionLoading
          }
        >
          <ModalLoader />
        </CheckRender>
      </MainContent>
    </LayoutContainer>
  );
};

const mapStateToProps = (state) => ({
  authUserData: state.auth.authUserData,
  //tipos solicitudes precertificacion
  tiposSolicitudesPrecertificacionLoading:
    state.precertificacion.tiposSolicitudesPrecertificacionLoading,
  tiposSolicitudesPrecertificacionError:
    state.precertificacion.tiposSolicitudesPrecertificacionError,
  tiposSolicitudesPrecertificacionData:
    state.precertificacion.tiposSolicitudesPrecertificacionData,
  //consultar una certificacion
  consultarUnaPrecertificacionLoading:
    state.precertificacion.consultarUnaPrecertificacionLoading,
  consultarUnaPrecertificacionError:
    state.precertificacion.consultarUnaPrecertificacionError,
  consultarUnaPrecertificacionData:
    state.precertificacion.consultarUnaPrecertificacionData,
  //modificar certificacion
  modificarCertificacionLoading:
    state.precertificacion.modificarPrecertificacionLoading,
  modificarCertificacionError:
    state.precertificacion.modificarPrecertificacionError,
  modificarCertificacionData:
    state.precertificacion.modificarPrecertificacionData
});

const mapDispatchToProps = {
  cargarTiposSolicitudesPrecertificacion:
    precertificacionTypes.tiposSolicitudesPrecertificacion,
  consultarUnaPrecertificacion:
    precertificacionTypes.consultarUnaPrecertificacion,
  modificarPrecertificacion: precertificacionTypes.modificarPrecertificacion
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(PrecertificacionModificarScreen);
